import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from 'src/services/authguard.service';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  // {path: 'home', loadChildren: () => import('./app.module').then(m => m.AppModule)},
  { path: 'order', loadChildren: () => import('./order/order.module').then(m => m.OrderModule) },
  {
    path: 'waiterorder', loadChildren: () => import('./waiterorder/waiterorder.module').then(m => m.WaiterorderModule)
    , canActivate: [AuthGuardService]
  },
  {
    path: 'table', loadChildren: () => import('./table/table.module').then(m => m.TableModule)
    , canActivate: [AuthGuardService]
  },
  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'about', loadChildren: () => import('./about/about.module').then(m => m.AboutModule) },
  { path: 'club', loadChildren: () => import('./club/club.module').then(m => m.ClubModule) },
  {
    path: 'ordermanagement', loadChildren: () => import('./ordermanagement/ordermanagement.module').then(m => m.OrdermanagementModule)
    , canActivate: [AuthGuardService]
  },
  {
    path: 'pay-setting', loadChildren: () => import('./setting/setting.module').then(m => m.SettingModule)
    , canActivate: [AuthGuardService]
  },
  {
    path: 'portal', loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule)
    , canActivate: [AuthGuardService]
  },
  { path: 'game', loadChildren: () => import('./game/game.module').then(m => m.GameModule) },
  {
    path: 'payment', loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule)
    // , canActivate: [ AuthGuardService ]
  },
  { path: 'finalfactor', loadChildren: () => import('./finalfactor/finalfactor.module').then(m => m.FinalfactorModule) },
  { path: '**', loadChildren: () => import('./notfound/not-found.module').then(m => m.NotFoundModule) },
  // {path: 'factor', loadChildren: () => import('./factor/factor.module').then(m => m.FactorModule)},

];

@NgModule({
  imports: [RouterModule.forRoot(routes // , //{
    // scrollPositionRestoration: 'enabled',
    // anchorScrolling: 'enabled',
    // scrollOffset: [0, 64] // [x, y]
    // }
    , { relativeLinkResolution: 'legacy', onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
